import axios from "axios";

const prodStem = "https://us-central1-utad-requests.cloudfunctions.net";
const devStem = "http://localhost:5000/utad-requests/us-central1";

const axiosInstance = axios.create({
  headers: {
    "content-type": "application/json"
  }
});

// Exporting the instance here so we can include it in tests
export const instance = axiosInstance;

function setStem(env) {
  const stem = env === "development" ? devStem : prodStem;
  return stem;
}

export function setEndpoint({ env, requestType }) {
  const stem = setStem(env);

  return `${stem}/${requestType}/requests/`;
}

export function setWarmUpEndpoint({ env, requestType }) {
  return `${setStem(env)}/${requestType}/prime/`;
}

// Send our data off to the server
export function sendUserRequest(requestJSON, requestType) {
  const endpoint = setEndpoint({
    env: process.env.NODE_ENV,
    requestType
  });

  return axiosInstance
    .post(endpoint, requestJSON)
    .then(res => {
      // Returning just the response body
      return res.data;
    })
    .catch(e => {
      // Only log in dev
      if (process.env.NODE_ENV === "development") {
        console.log(e);
      }

      // Throwing here so we can handle the error at the call site using 'catch()'
      throw e;
    });
}

// A fire-and-forget function to hit our cloud function endpoint and reduce latency when the end user actually submits their request
export function warmUpCloudFunction(requestType) {
  const endpoint = setWarmUpEndpoint({
    env: process.env.NODE_ENV,
    requestType
  });

  return axiosInstance.options(endpoint);
}



// WEBPACK FOOTER //
// ./src/util/api.js